import { Grid, Hidden, SelectableChipSmall, Tab, Tabs, useTheme } from '@paintscout/ui'
import React, { useEffect, useState } from 'react'
import { setUrlQuery } from 'shared/util/routing'
import { useLocation } from 'react-router-dom'
import Calendar, { CalendarProvider, useCalendar } from '../../common/Calendar'
import MapViewSwitcher from '../../common/MapViewSwitcher'

function ViewChips() {
  const theme = useTheme()
  const { view, setView } = useCalendar()
  const chipStyle = { backgroundColor: theme.paintscout.palette.brand.Neutral.P94 }
  return (
    <>
      <SelectableChipSmall label="Day" selected={view === 'day'} onClick={() => setView('day')} style={chipStyle} />
      <SelectableChipSmall label="Week" selected={view === 'week'} onClick={() => setView('week')} style={chipStyle} />
      <SelectableChipSmall
        label="Month"
        selected={view === 'month'}
        onClick={() => setView('month')}
        style={chipStyle}
      />
    </>
  )
}

function MobileViewSwitcher() {
  const { view, setView } = useCalendar()
  return <MapViewSwitcher value={view} onChange={setView} />
}

export default function EventsView() {
  const [tab, setTab] = useState<'calendar' | 'map' | 'schedule'>('calendar')
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('map')) {
      setTab('map')
    } else {
      setTab('calendar')
    }
  }, [location.pathname])

  return (
    <CalendarProvider tab={tab}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
        <Grid item>
          <Tabs
            value={tab}
            onChange={(_, value) => {
              if (value === 'map') {
                location.pathname = '/events/?tab=map'
              } else if (value === 'calendar') {
                location.pathname = '/events/?tab=calendar'
              }
              setUrlQuery({
                location,
                replaceParams: true,
                params: {
                  search: null,
                  filter: null
                }
              })
            }}
          >
            <Tab label="Calendar" value="calendar" onClick={() => setTab('calendar')} />
            <Tab label="Map" value="map" onClick={() => setTab('map')} />
          </Tabs>
        </Grid>

        {(tab === 'calendar' || tab === 'map') && (
          <Hidden xsDown>
            <Grid item xs container justifyContent="flex-end" alignItems="center" style={{ gap: 8 }}>
              <ViewChips />
            </Grid>
          </Hidden>
        )}

        {(tab === 'calendar' || tab === 'map') && (
          <Hidden smUp>
            <Grid item>
              <MobileViewSwitcher />
            </Grid>
          </Hidden>
        )}

        <Grid item xs={12}>
          {(tab === 'calendar' || tab === 'map') && <Calendar />}
          {tab === 'schedule' && <div>Schedule</div>}
        </Grid>
      </Grid>
    </CalendarProvider>
  )
}
